import React from 'react';

const Requirements: React.FC = () => {
  const requirements = [
    {
      title: 'العمر والهوية',
      items: [
        'العمر: 18 سنة فما فوق',
        'بطاقة هوية سارية المفعول',
        'صورة شخصية ملونة',
        'إثبات السكن'
      ]
    },
    {
      title: 'الفحص الطبي',
      items: [
        'فحص النظر (إجباري)',
        'شهادة طبية معتمدة (لفحص النظر)',
      ]
    },
    {
      title: 'المستندات المطلوبة',
      items: [
        'استمارة طلب الرخصة',
        'صور شخصية 4×6',
        'رسوم الطلب والفحص',
        'كفيل (إن أمكن)'
      ]
    },
    {
      title: 'التدريب والاختبار',
      items: [
        'حضور الدروس النظرية',
        'إتمام ساعات التدريب العملي',
        'اجتياز الاختبار النظري',
        'اجتياز الاختبار العملي'
      ]
    }
  ];

  return (
    <section id="requirements" className="py-16 md:py-32 bg-gradient-to-br from-alice-blue to-white overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center max-w-5xl mx-auto mb-12 md:mb-20">
          <div className="inline-flex items-center bg-lapis-lazuli/10 border border-lapis-lazuli/20 text-lapis-lazuli px-4 md:px-8 py-2 md:py-4 rounded-full text-xs md:text-sm font-medium mb-6 md:mb-10 fade-in">
            المتطلبات والشروط
          </div>
          <h2 className="text-3xl md:text-6xl lg:text-7xl font-black text-prussian-blue mb-6 md:mb-10 leading-tight fade-in fade-in-delay-1">
            ما تحتاجينه لبدء رحلتكِ<span className="text-celestial-blue">.</span>
          </h2>
          <p className="text-lg md:text-2xl text-prussian-blue/70 leading-relaxed max-w-4xl mx-auto px-4 fade-in fade-in-delay-2">
            إليكِ كل ما تحتاجين معرفته والاستعداد له قبل البدء في رحلة تعلم القيادة معنا
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 max-w-6xl mx-auto px-2">
          {requirements.map((req, index) => (
            <div key={index} className="group">
              <div className={`bg-white/80 backdrop-blur-sm rounded-2xl md:rounded-3xl p-6 md:p-10 shadow-lg hover:shadow-2xl transition-all duration-700 scale-hover border border-lapis-lazuli/10 hover:border-celestial-blue/30 h-full fade-in`}
                   style={{animationDelay: `${(index + 3) * 0.2}s`}}>
                <div className="text-center mb-6 md:mb-10">
                  <h3 className="text-xl md:text-3xl font-bold text-prussian-blue leading-tight group-hover:text-celestial-blue transition-colors duration-300">{req.title}</h3>
                  <div className="w-16 h-1 bg-celestial-blue rounded-full mx-auto mt-4 md:mt-6 transform transition-all duration-500 group-hover:w-20"></div>
                </div>
                
                <ul className="space-y-3 md:space-y-5">
                  {req.items.map((item, itemIndex) => (
                    <li 
                      key={itemIndex} 
                      className="flex items-start group/item transition-all duration-300"
                    >
                      <div className="w-2 h-2 bg-celestial-blue rounded-full mt-2 ml-3 flex-shrink-0 transform transition-all duration-300 group-hover/item:scale-150"></div>
                      <span className="text-prussian-blue/70 leading-relaxed text-sm md:text-lg group-hover/item:text-prussian-blue transition-colors duration-300">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Important Note */}
        <div className="mt-12 md:mt-20 text-center fade-in fade-in-delay-4">
          <div className="bg-celestial-blue/10 backdrop-blur-lg rounded-2xl md:rounded-3xl p-6 md:p-12 border border-celestial-blue/20 max-w-5xl mx-auto hover:bg-celestial-blue/15 transition-all duration-500 group scale-hover">
            <div className="text-celestial-blue text-3xl md:text-5xl mb-4 md:mb-6 transform transition-all duration-300 group-hover:scale-110">⚠️</div>
            <h3 className="text-xl md:text-3xl font-bold text-prussian-blue mb-4 md:mb-8 group-hover:text-celestial-blue transition-colors duration-300">ملاحظة مهمة</h3>
            <p className="text-prussian-blue/70 leading-relaxed text-sm md:text-xl max-w-3xl mx-auto group-hover:text-prussian-blue transition-colors duration-300">
              يُنصح بالتواصل معنا قبل التسجيل للتأكد من اكتمال جميع المستندات المطلوبة وتجنب أي تأخير في بدء التدريب
            </p>
          </div>
        </div>

        {/* Quick Tips */}
        <div className="mt-12 md:mt-20 fade-in fade-in-delay-4">
          <div className="bg-white/60 backdrop-blur-lg rounded-2xl md:rounded-3xl p-6 md:p-12 border border-lapis-lazuli/20 max-w-5xl mx-auto hover:bg-white/70 transition-all duration-500 scale-hover">
            <h3 className="text-xl md:text-3xl font-bold text-prussian-blue mb-6 md:mb-12 text-center">نصائح سريعة</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-10">
              {[
                { num: '1', title: 'حضري المستندات مسبقاً', desc: 'لتسريع عملية التسجيل' },
                { num: '2', title: 'احجزي الفحص الطبي', desc: 'في أقرب وقت ممكن' },
                { num: '3', title: 'تأكدي من صحة المعلومات', desc: 'قبل تقديم الطلب' },
                { num: '4', title: 'تواصلي معنا', desc: 'لأي استفسارات إضافية' }
              ].map((tip, index) => (
                <div 
                  key={index}
                  className="flex items-start group transition-all duration-300"
                >
                  <div className="w-8 h-8 bg-celestial-blue rounded-full flex items-center justify-center flex-shrink-0 mt-1 transform transition-all duration-300 group-hover:scale-125 group-hover:bg-lapis-lazuli">
                    <span className="text-white text-sm font-bold">{tip.num}</span>
                  </div>
                  <div className="mr-4">
                    <h4 className="font-bold text-prussian-blue text-sm md:text-lg mb-1 md:mb-2 group-hover:text-celestial-blue transition-colors duration-300">{tip.title}</h4>
                    <p className="text-prussian-blue/70 text-xs md:text-base leading-relaxed group-hover:text-prussian-blue transition-colors duration-300">{tip.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Requirements; 